// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import PropTypes from 'prop-types'
import moment from 'moment'


export const DateTime = ({ children, format }) => (
  children
    ? moment(children).format(format)
    : '-'
)

DateTime.propTypes = {
  children: PropTypes.string,
  format: PropTypes.string
}

DateTime.defaultProps = {
  format: 'DD MMM YYYY hh:mm'
}



// WEBPACK FOOTER //
// ./src/components/date-time/index.js